import React from "react";
import { withState } from "recompose";
import Modal from "react-responsive-modal";

import IconInfo from "./icons/Info";
import IconInfoSmall from "./icons/InfoSmall";

const InfoModal = ({
  open,
  setOpen,
  title,
  buttonText,
  buttonColor = "grey-darker",
  withIcon = true,
  children,
  dataTestValue,
  alwaysOnUnderline = false,
}) => {
  const underlinePrefix = alwaysOnUnderline ? '' : 'hover:'

  return <>
    <button
      className={`inline-flex items-center text-${buttonColor}`}
      onClick={() => setOpen(true)}
      data-cy={dataTestValue}
    >
      {buttonText && (
        <span className={`inline-flex ${underlinePrefix}shadow-underline font-semibold`}>{buttonText}</span>
      )}
      {withIcon && (
        <span className="inline-flex ml-1">
          <IconInfoSmall />
        </span>
      )}
    </button>
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      center
      className={{ overlay: "p-3", modal: "p-7 w-full rounded" }}
    >
      <>
        {withIcon && (
          <div className="text-secondary flex justify-center mb-4 mt-10 leading-wide">
            <IconInfo />
          </div>
        )}

        <h4
          className={`headline--4 mb-2 ${
            withIcon ? "mt-0 text-center" : "mt-5"
          }`}
        >
          {title}
        </h4>
        <div className="mb-10">{children}</div>
      </>
    </Modal>
  </>
};

export default withState("open", "setOpen", false)(InfoModal);
